<template>
  <l-map :zoom="zoom" :center="center">
    <l-tile-layer :url="url" />
    <l-feature-group>
      <template v-for="org in ngos">
        <l-marker
          v-if="org.mainHQ && org.mainHQ.longitude && org.mainHQ.latitude"
          @click="$emit('ngoMarkerClicked', org.id)"
          :key="org.id"
          :icon="icon"
          :lat-lng="[org.mainHQ.latitude, org.mainHQ.longitude]"
        >
          <!-- <l-popup :options="{ permenant: true }">
          <div class="text-center">
            <div class="my-50" style="font-size: 16px">
              {{ org.name_ar }}
            </div>
            <b-button
              variant="success"
              size="sm"
              @click="
                $router.push({ name: 'ngo-home', params: { id: org.id } })
              "
              >انتقال</b-button
            >
          </div>
        </l-popup> -->
        </l-marker>
      </template>
      s
    </l-feature-group>
  </l-map>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LCircle,
  LMarker,
  LTooltip,
  LPopup,
  LFeatureGroup,
} from "vue2-leaflet";
import { BButton } from "bootstrap-vue";
import { latLng, icon } from "leaflet";
import "leaflet/dist/leaflet.css";
export default {
  components: {
    LMap,
    LFeatureGroup,
    LTileLayer,
    LCircle,
    BButton,
    LTooltip,
    LMarker,
    LPopup,
  },
  props: {
    ngos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 7,
      center: [33.5167, 36.9541],
      circle: {
        center: [33.5167, 36.9541],
        radius: 10000,
        color: "#EA5455",
      },
      icon: icon({
        iconUrl: "/images/marker-icon.png",
      }),
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/map-leaflet.scss";

.vue2leaflet-map {
  &.leaflet-container {
    height: 550px;
  }
}
</style>
